//custom code
(() => {
  const settings = window.theme?.settings;
  if (!settings) return;

  const { cart_gift_enabled, cart_gift_threshold, cart_gift_variant_id } = settings;

  if (!cart_gift_enabled || !cart_gift_threshold || !cart_gift_variant_id) return;

  const THRESHOLD = Number(cart_gift_threshold);
  const GIFT_VARIANT_ID = String(cart_gift_variant_id);

  if (!THRESHOLD || THRESHOLD <= 0 || !GIFT_VARIANT_ID) return;

  const CART_ENDPOINT_PATTERNS = ['/cart/add', '/cart/change', '/cart/update'];
  let _isGiftOperation = false;
  let _pendingCheck = null;

  function isCartMutationEndpoint(url) {
    try {
      const pathname = new URL(url, window.location.origin).pathname;
      return CART_ENDPOINT_PATTERNS.some(ep => pathname.includes(ep));
    } catch {
      return CART_ENDPOINT_PATTERNS.some(ep => String(url).includes(ep));
    }
  }

  function setCartLoading(loading) {
    const cartItemsEl = document.querySelector('cart-items');
    const cartDrawerItemsEl = document.querySelector('cart-drawer-items');

    if (cartItemsEl) {
      cartItemsEl.classList.toggle('is-loading', loading);
    }
    if (cartDrawerItemsEl) {
      cartDrawerItemsEl.classList.toggle('is-loading', loading);
    }
  }

  async function fetchCart() {
    const cartUrl = `${window.routes?.cart_url || '/cart'}.js`;
    const res = await _originalFetch.call(window, cartUrl, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!res.ok) throw new Error(`Failed to fetch cart: ${res.status}`);
    return res.json();
  }

  function getQualifyingTotal(cart) {
    return cart.items.reduce((sum, item) => {
      if (String(item.variant_id) === GIFT_VARIANT_ID) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  function findGiftItem(cart) {
    for (let i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === GIFT_VARIANT_ID) {
        return { item: cart.items[i], line: i + 1 };
      }
    }
    return null;
  }

  function getSectionsToRequest() {
    const sections = [];
    if (document.querySelector('cart-drawer')) {
      sections.push('cart-drawer');
    }
    const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
    if (mainCartId) {
      sections.push(mainCartId);
    }
    sections.push('cart-counter');
    return sections;
  }

  function getSectionMappings() {
    const mappings = [];
    const mainCartId = document.getElementById('main-cart-items')?.dataset.id;

    if (document.querySelector('cart-drawer')) {
      mappings.push({
        id: '#CartDrawer-Body',
        section: 'cart-drawer',
        selector: '#shopify-section-cart-drawer #CartDrawer-Body',
      });
    }
    if (mainCartId) {
      mappings.push({
        id: `#shopify-section-${mainCartId}`,
        section: mainCartId,
        selector: `#shopify-section-${mainCartId} cart-items`,
      });
    }
    mappings.push({
      id: '#cart-counter',
      section: 'cart-counter',
      selector: '#shopify-section-cart-counter',
    });
    return mappings;
  }

  function refreshCartSections(sectionsHtml) {
    if (!sectionsHtml) return;

    const mappings = getSectionMappings();
    mappings.forEach(({ id, section, selector }) => {
      const html = sectionsHtml[section];
      if (!html) return;
      const target = document.querySelector(selector) || document.querySelector(id);
      if (!target) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.querySelector(selector);
      if (source) {
        target.innerHTML = source.innerHTML;
      }
    });

    if (typeof updateCartCounters === 'function') updateCartCounters();
    if (typeof updateFreeShipping === 'function') updateFreeShipping();
    // custom code start
    if (typeof updateCheckoutButtons === 'function') updateCheckoutButtons();
    // custom code end
  }

  async function addGiftToCart() {
    const addUrl = `${window.routes?.cart_add_url || '/cart/add'}.js`;
    const sections = getSectionsToRequest();
    const res = await _originalFetch.call(window, addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: GIFT_VARIANT_ID, quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname,
      }),
    });
    if (!res.ok) throw new Error(`Failed to add gift: ${res.status}`);
    return res.json();
  }

  async function changeGiftQuantity(line, quantity) {
    const changeUrl = `${window.routes?.cart_change_url || '/cart/change'}.js`;
    const sections = getSectionsToRequest();
    const res = await _originalFetch.call(window, changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: sections,
        sections_url: window.location.pathname,
      }),
    });
    if (!res.ok) throw new Error(`Failed to change gift qty: ${res.status}`);
    return res.json();
  }

  function needsGiftAction(cart) {
    const qualifyingTotal = getQualifyingTotal(cart);
    const giftInfo = findGiftItem(cart);

    if (qualifyingTotal >= THRESHOLD) {
      if (!giftInfo) return 'add';
      if (giftInfo.item.quantity > 1) return 'fix_qty';
      return null;
    }
    if (giftInfo) return 'remove';
    return null;
  }

  async function checkAndManageGift() {
    if (_isGiftOperation) return;
    _isGiftOperation = true;
    try {
      const cart = await fetchCart();
      const action = needsGiftAction(cart);

      if (!action) {
        _isGiftOperation = false;
        return;
      }

      setCartLoading(true);

      const giftInfo = findGiftItem(cart);
      let response;

      if (action === 'add') {
        response = await addGiftToCart();
      } else if (action === 'fix_qty') {
        response = await changeGiftQuantity(giftInfo.line, 1);
      } else if (action === 'remove') {
        response = await changeGiftQuantity(giftInfo.line, 0);
      }

      if (response) {
        refreshCartSections(response.sections);
      }
    } catch (err) {
      console.error('[CartGift]', err.message);
    } finally {
      setCartLoading(false);
      _isGiftOperation = false;
    }
  }

  function scheduleGiftCheck() {
    if (_pendingCheck) clearTimeout(_pendingCheck);
    _pendingCheck = setTimeout(() => {
      _pendingCheck = null;
      checkAndManageGift();
    }, 300);
  }

  const _originalFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    const result = _originalFetch.apply(this, arguments);

    if (_isGiftOperation) return result;

    const url = input instanceof Request ? input.url : String(input);
    if (isCartMutationEndpoint(url)) {
      result.then(() => scheduleGiftCheck()).catch(() => {});
    }

    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => checkAndManageGift());
  } else {
    checkAndManageGift();
  }
})();
